// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseComponent } from '../../../../../com/MetaPattern/MDA/MD/Base/BaseComponent';
import { ComponentDepend } from './ComponentDepend';
import { BEComment } from './BEComment';
import { BEEntity } from './BEEntity';
import { BEInterface } from './BEInterface';
import { BEValueObject } from './BEValueObject';
import { EntityGeneration } from './EntityGeneration';
import { BEReferenceEntity } from './BEReferenceEntity';
import { BEDTO } from './BEDTO';
import { BEBusinessLogic } from './BEBusinessLogic';
import { BEService } from './BEService';
import { BEEnum } from './BEEnum';
import { BEConstant } from './BEConstant';
import { BEImportNamespace } from './BEImportNamespace';
import { InterfaceGeneration } from './InterfaceGeneration';
import { Implement } from './Implement';
import { Association } from './Association';
import { Aggregation } from './Aggregation';
import { Composition } from './Composition';
import { CrossAssociation } from './CrossAssociation';
import { ReferCrossAssociation } from './ReferCrossAssociation';
import { BEException } from './BEException';
import { DependencyAssociation } from './DependencyAssociation';
import { BEDistributedTransaction } from './BEDistributedTransaction';
import { BEExternalService } from './BEExternalService';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { BEComponentExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/BEComponentExtend';
/**
 * 实体模型组件 实体类
 * 实体模型组件，定义实体模型
 */
export class BEComponent extends BaseComponent {
  /** 被组件依赖 */
  private _componentDependeds: Array<ComponentDepend>;

  /** 获取：被组件依赖 */
  public get componentDependeds() {
    return this._componentDependeds;
  }

  /** 设置：被组件依赖 */
  public set componentDependeds(value: Array<ComponentDepend>) {
    this._componentDependeds = value;
  }

  /** 组件依赖 */
  private _componentDepends: Array<ComponentDepend>;

  /** 获取：组件依赖 */
  public get componentDepends() {
    return this._componentDepends;
  }

  /** 设置：组件依赖 */
  public set componentDepends(value: Array<ComponentDepend>) {
    this._componentDepends = value;
  }

  /** 注释 */
  private _comments: Array<BEComment>;

  /** 获取：注释 */
  public get comments() {
    return this._comments;
  }

  /** 设置：注释 */
  public set comments(value: Array<BEComment>) {
    this._comments = value;
  }

  /** 实体 */
  private _entities: Array<BEEntity>;

  /** 获取：实体 */
  public get entities() {
    return this._entities;
  }

  /** 设置：实体 */
  public set entities(value: Array<BEEntity>) {
    this._entities = value;
  }

  /** 接口 */
  private _interfaces: Array<BEInterface>;

  /** 获取：接口 */
  public get interfaces() {
    return this._interfaces;
  }

  /** 设置：接口 */
  public set interfaces(value: Array<BEInterface>) {
    this._interfaces = value;
  }

  /** 值对象 */
  private _valueObjects: Array<BEValueObject>;

  /** 获取：值对象 */
  public get valueObjects() {
    return this._valueObjects;
  }

  /** 设置：值对象 */
  public set valueObjects(value: Array<BEValueObject>) {
    this._valueObjects = value;
  }

  /** 实体继承关系 */
  private _entityGenerations: Array<EntityGeneration>;

  /** 获取：实体继承关系 */
  public get entityGenerations() {
    return this._entityGenerations;
  }

  /** 设置：实体继承关系 */
  public set entityGenerations(value: Array<EntityGeneration>) {
    this._entityGenerations = value;
  }

  /** 引用实体 */
  private _referenceEntities: Array<BEReferenceEntity>;

  /** 获取：引用实体 */
  public get referenceEntities() {
    return this._referenceEntities;
  }

  /** 设置：引用实体 */
  public set referenceEntities(value: Array<BEReferenceEntity>) {
    this._referenceEntities = value;
  }

  /** 数据传输对象 */
  private _dTOes: Array<BEDTO>;

  /** 获取：数据传输对象 */
  public get dTOes() {
    return this._dTOes;
  }

  /** 设置：数据传输对象 */
  public set dTOes(value: Array<BEDTO>) {
    this._dTOes = value;
  }

  /** 商业逻辑 */
  private _businessLogics: Array<BEBusinessLogic>;

  /** 获取：商业逻辑 */
  public get businessLogics() {
    return this._businessLogics;
  }

  /** 设置：商业逻辑 */
  public set businessLogics(value: Array<BEBusinessLogic>) {
    this._businessLogics = value;
  }

  /** 服务 */
  private _services: Array<BEService>;

  /** 获取：服务 */
  public get services() {
    return this._services;
  }

  /** 设置：服务 */
  public set services(value: Array<BEService>) {
    this._services = value;
  }

  /** 枚举 */
  private _enums: Array<BEEnum>;

  /** 获取：枚举 */
  public get enums() {
    return this._enums;
  }

  /** 设置：枚举 */
  public set enums(value: Array<BEEnum>) {
    this._enums = value;
  }

  /** 常量 */
  private _constants: Array<BEConstant>;

  /** 获取：常量 */
  public get constants() {
    return this._constants;
  }

  /** 设置：常量 */
  public set constants(value: Array<BEConstant>) {
    this._constants = value;
  }

  /** 导入名空间 */
  private _importNamespaces: Array<BEImportNamespace>;

  /** 获取：导入名空间 */
  public get importNamespaces() {
    return this._importNamespaces;
  }

  /** 设置：导入名空间 */
  public set importNamespaces(value: Array<BEImportNamespace>) {
    this._importNamespaces = value;
  }

  /** 接口继承关系 */
  private _interfaceGenerations: Array<InterfaceGeneration>;

  /** 获取：接口继承关系 */
  public get interfaceGenerations() {
    return this._interfaceGenerations;
  }

  /** 设置：接口继承关系 */
  public set interfaceGenerations(value: Array<InterfaceGeneration>) {
    this._interfaceGenerations = value;
  }

  /** 实现关系 */
  private _implements: Array<Implement>;

  /** 获取：实现关系 */
  public get implements() {
    return this._implements;
  }

  /** 设置：实现关系 */
  public set implements(value: Array<Implement>) {
    this._implements = value;
  }

  /** 关联关系 */
  private _associations: Array<Association>;

  /** 获取：关联关系 */
  public get associations() {
    return this._associations;
  }

  /** 设置：关联关系 */
  public set associations(value: Array<Association>) {
    this._associations = value;
  }

  /** 聚合关系 */
  private _aggregations: Array<Aggregation>;

  /** 获取：聚合关系 */
  public get aggregations() {
    return this._aggregations;
  }

  /** 设置：聚合关系 */
  public set aggregations(value: Array<Aggregation>) {
    this._aggregations = value;
  }

  /** 组合关系 */
  private _compositions: Array<Composition>;

  /** 获取：组合关系 */
  public get compositions() {
    return this._compositions;
  }

  /** 设置：组合关系 */
  public set compositions(value: Array<Composition>) {
    this._compositions = value;
  }

  /** 交叉关联关系 */
  private _crossAssociations: Array<CrossAssociation>;

  /** 获取：交叉关联关系 */
  public get crossAssociations() {
    return this._crossAssociations;
  }

  /** 设置：交叉关联关系 */
  public set crossAssociations(value: Array<CrossAssociation>) {
    this._crossAssociations = value;
  }

  /** 引用交叉关联关系 */
  private _referCrossAssociations: Array<ReferCrossAssociation>;

  /** 获取：引用交叉关联关系 */
  public get referCrossAssociations() {
    return this._referCrossAssociations;
  }

  /** 设置：引用交叉关联关系 */
  public set referCrossAssociations(value: Array<ReferCrossAssociation>) {
    this._referCrossAssociations = value;
  }

  /** 异常 */
  private _exceptions: Array<BEException>;

  /** 获取：异常 */
  public get exceptions() {
    return this._exceptions;
  }

  /** 设置：异常 */
  public set exceptions(value: Array<BEException>) {
    this._exceptions = value;
  }

  /** 依赖关系 */
  private _dependencyAssociations: Array<DependencyAssociation>;

  /** 获取：依赖关系 */
  public get dependencyAssociations() {
    return this._dependencyAssociations;
  }

  /** 设置：依赖关系 */
  public set dependencyAssociations(value: Array<DependencyAssociation>) {
    this._dependencyAssociations = value;
  }

  /** 分布式事务 */
  private _distributedTransactions: Array<BEDistributedTransaction>;

  /** 获取：分布式事务 */
  public get distributedTransactions() {
    return this._distributedTransactions;
  }

  /** 设置：分布式事务 */
  public set distributedTransactions(value: Array<BEDistributedTransaction>) {
    this._distributedTransactions = value;
  }

  /** 外部服务 */
  private _externalServices: Array<BEExternalService>;

  /** 获取：外部服务 */
  public get externalServices() {
    return this._externalServices;
  }

  /** 设置：外部服务 */
  public set externalServices(value: Array<BEExternalService>) {
    this._externalServices = value;
  }

  constructor() {
    super();
    BEComponentExtend.Init(this);
    this._componentDependeds = new Array<ComponentDepend>();
    this._componentDepends = new Array<ComponentDepend>();
    this._comments = new Array<BEComment>();
    this._entities = new Array<BEEntity>();
    this._interfaces = new Array<BEInterface>();
    this._valueObjects = new Array<BEValueObject>();
    this._entityGenerations = new Array<EntityGeneration>();
    this._referenceEntities = new Array<BEReferenceEntity>();
    this._dTOes = new Array<BEDTO>();
    this._businessLogics = new Array<BEBusinessLogic>();
    this._services = new Array<BEService>();
    this._enums = new Array<BEEnum>();
    this._constants = new Array<BEConstant>();
    this._importNamespaces = new Array<BEImportNamespace>();
    this._interfaceGenerations = new Array<InterfaceGeneration>();
    this._implements = new Array<Implement>();
    this._associations = new Array<Association>();
    this._aggregations = new Array<Aggregation>();
    this._compositions = new Array<Composition>();
    this._crossAssociations = new Array<CrossAssociation>();
    this._referCrossAssociations = new Array<ReferCrossAssociation>();
    this._exceptions = new Array<BEException>();
    this._dependencyAssociations = new Array<DependencyAssociation>();
    this._distributedTransactions = new Array<BEDistributedTransaction>();
    this._externalServices = new Array<BEExternalService>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEComponent, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    if (json.ComponentDependeds && json.ComponentDependeds.length > 0) {
      json.ComponentDependeds.forEach((element: any) => {
        const componentDepend = ComponentDepend.Create(element);
        // componentDepend.dependComponent = this;
        this.componentDependeds.push(componentDepend);
      });
    }
    if (json.ComponentDepends && json.ComponentDepends.length > 0) {
      json.ComponentDepends.forEach((element: any) => {
        const componentDepend = ComponentDepend.Create(element);
        // componentDepend.dependedComponent = this;
        this.componentDepends.push(componentDepend);
      });
    }
    if (json.Comments && json.Comments.length > 0) {
      json.Comments.forEach((element: any) => {
        const bEComment = BEComment.Create(element);
        // bEComment.component = this;
        this.comments.push(bEComment);
      });
    }
    if (json.Entities && json.Entities.length > 0) {
      json.Entities.forEach((element: any) => {
        const bEEntity = BEEntity.Create(element);
        // bEEntity.component = this;
        this.entities.push(bEEntity);
      });
    }
    if (json.Interfaces && json.Interfaces.length > 0) {
      json.Interfaces.forEach((element: any) => {
        const bEInterface = BEInterface.Create(element);
        // bEInterface.component = this;
        this.interfaces.push(bEInterface);
      });
    }
    if (json.ValueObjects && json.ValueObjects.length > 0) {
      json.ValueObjects.forEach((element: any) => {
        const bEValueObject = BEValueObject.Create(element);
        // bEValueObject.component = this;
        this.valueObjects.push(bEValueObject);
      });
    }
    if (json.EntityGenerations && json.EntityGenerations.length > 0) {
      json.EntityGenerations.forEach((element: any) => {
        const entityGeneration = EntityGeneration.Create(element);
        // entityGeneration.component = this;
        this.entityGenerations.push(entityGeneration);
      });
    }
    if (json.ReferenceEntities && json.ReferenceEntities.length > 0) {
      json.ReferenceEntities.forEach((element: any) => {
        const bEReferenceEntity = BEReferenceEntity.Create(element);
        // bEReferenceEntity.component = this;
        this.referenceEntities.push(bEReferenceEntity);
      });
    }
    if (json.DTOes && json.DTOes.length > 0) {
      json.DTOes.forEach((element: any) => {
        const bEDTO = BEDTO.Create(element);
        // bEDTO.component = this;
        this.dTOes.push(bEDTO);
      });
    }
    if (json.BusinessLogics && json.BusinessLogics.length > 0) {
      json.BusinessLogics.forEach((element: any) => {
        const bEBusinessLogic = BEBusinessLogic.Create(element);
        // bEBusinessLogic.component = this;
        this.businessLogics.push(bEBusinessLogic);
      });
    }
    if (json.Services && json.Services.length > 0) {
      json.Services.forEach((element: any) => {
        const bEService = BEService.Create(element);
        // bEService.component = this;
        this.services.push(bEService);
      });
    }
    if (json.Enums && json.Enums.length > 0) {
      json.Enums.forEach((element: any) => {
        const bEEnum = BEEnum.Create(element);
        // bEEnum.component = this;
        this.enums.push(bEEnum);
      });
    }
    if (json.Constants && json.Constants.length > 0) {
      json.Constants.forEach((element: any) => {
        const bEConstant = BEConstant.Create(element);
        // bEConstant.component = this;
        this.constants.push(bEConstant);
      });
    }
    if (json.ImportNamespaces && json.ImportNamespaces.length > 0) {
      json.ImportNamespaces.forEach((element: any) => {
        const bEImportNamespace = BEImportNamespace.Create(element);
        // bEImportNamespace.component = this;
        this.importNamespaces.push(bEImportNamespace);
      });
    }
    if (json.InterfaceGenerations && json.InterfaceGenerations.length > 0) {
      json.InterfaceGenerations.forEach((element: any) => {
        const interfaceGeneration = InterfaceGeneration.Create(element);
        // interfaceGeneration.component = this;
        this.interfaceGenerations.push(interfaceGeneration);
      });
    }
    if (json.Implements && json.Implements.length > 0) {
      json.Implements.forEach((element: any) => {
        const implement = Implement.Create(element);
        // implement.component = this;
        this.implements.push(implement);
      });
    }
    if (json.Associations && json.Associations.length > 0) {
      json.Associations.forEach((element: any) => {
        const association = Association.Create(element);
        // association.component = this;
        this.associations.push(association);
      });
    }
    if (json.Aggregations && json.Aggregations.length > 0) {
      json.Aggregations.forEach((element: any) => {
        const aggregation = Aggregation.Create(element);
        // aggregation.component = this;
        this.aggregations.push(aggregation);
      });
    }
    if (json.Compositions && json.Compositions.length > 0) {
      json.Compositions.forEach((element: any) => {
        const composition = Composition.Create(element);
        // composition.component = this;
        this.compositions.push(composition);
      });
    }
    if (json.CrossAssociations && json.CrossAssociations.length > 0) {
      json.CrossAssociations.forEach((element: any) => {
        const crossAssociation = CrossAssociation.Create(element);
        // crossAssociation.component = this;
        this.crossAssociations.push(crossAssociation);
      });
    }
    if (json.ReferCrossAssociations && json.ReferCrossAssociations.length > 0) {
      json.ReferCrossAssociations.forEach((element: any) => {
        const referCrossAssociation = ReferCrossAssociation.Create(element);
        // referCrossAssociation.component = this;
        this.referCrossAssociations.push(referCrossAssociation);
      });
    }
    if (json.Exceptions && json.Exceptions.length > 0) {
      json.Exceptions.forEach((element: any) => {
        const bEException = BEException.Create(element);
        // bEException.component = this;
        this.exceptions.push(bEException);
      });
    }
    if (json.DependencyAssociations && json.DependencyAssociations.length > 0) {
      json.DependencyAssociations.forEach((element: any) => {
        const dependencyAssociation = DependencyAssociation.Create(element);
        // dependencyAssociation.component = this;
        this.dependencyAssociations.push(dependencyAssociation);
      });
    }
    if (json.DistributedTransactions && json.DistributedTransactions.length > 0) {
      json.DistributedTransactions.forEach((element: any) => {
        const bEDistributedTransaction = BEDistributedTransaction.Create(element);
        // bEDistributedTransaction.component = this;
        this.distributedTransactions.push(bEDistributedTransaction);
      });
    }
    if (json.ExternalServices && json.ExternalServices.length > 0) {
      json.ExternalServices.forEach((element: any) => {
        const bEExternalService = BEExternalService.Create(element);
        // bEExternalService.component = this;
        this.externalServices.push(bEExternalService);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    if (this.componentDependeds && this.componentDependeds.length > 0) {
      json.ComponentDependeds = [];
      this.componentDependeds.forEach((element) => {
        json.ComponentDependeds.push(element.toJson());
      });
    }
    if (this.componentDepends && this.componentDepends.length > 0) {
      json.ComponentDepends = [];
      this.componentDepends.forEach((element) => {
        json.ComponentDepends.push(element.toJson());
      });
    }
    if (this.comments && this.comments.length > 0) {
      json.Comments = [];
      this.comments.forEach((element) => {
        json.Comments.push(element.toJson());
      });
    }
    if (this.entities && this.entities.length > 0) {
      json.Entities = [];
      this.entities.forEach((element) => {
        json.Entities.push(element.toJson());
      });
    }
    if (this.interfaces && this.interfaces.length > 0) {
      json.Interfaces = [];
      this.interfaces.forEach((element) => {
        json.Interfaces.push(element.toJson());
      });
    }
    if (this.valueObjects && this.valueObjects.length > 0) {
      json.ValueObjects = [];
      this.valueObjects.forEach((element) => {
        json.ValueObjects.push(element.toJson());
      });
    }
    if (this.entityGenerations && this.entityGenerations.length > 0) {
      json.EntityGenerations = [];
      this.entityGenerations.forEach((element) => {
        json.EntityGenerations.push(element.toJson());
      });
    }
    if (this.referenceEntities && this.referenceEntities.length > 0) {
      json.ReferenceEntities = [];
      this.referenceEntities.forEach((element) => {
        json.ReferenceEntities.push(element.toJson());
      });
    }
    if (this.dTOes && this.dTOes.length > 0) {
      json.DTOes = [];
      this.dTOes.forEach((element) => {
        json.DTOes.push(element.toJson());
      });
    }
    if (this.businessLogics && this.businessLogics.length > 0) {
      json.BusinessLogics = [];
      this.businessLogics.forEach((element) => {
        json.BusinessLogics.push(element.toJson());
      });
    }
    if (this.services && this.services.length > 0) {
      json.Services = [];
      this.services.forEach((element) => {
        json.Services.push(element.toJson());
      });
    }
    if (this.enums && this.enums.length > 0) {
      json.Enums = [];
      this.enums.forEach((element) => {
        json.Enums.push(element.toJson());
      });
    }
    if (this.constants && this.constants.length > 0) {
      json.Constants = [];
      this.constants.forEach((element) => {
        json.Constants.push(element.toJson());
      });
    }
    if (this.importNamespaces && this.importNamespaces.length > 0) {
      json.ImportNamespaces = [];
      this.importNamespaces.forEach((element) => {
        json.ImportNamespaces.push(element.toJson());
      });
    }
    if (this.interfaceGenerations && this.interfaceGenerations.length > 0) {
      json.InterfaceGenerations = [];
      this.interfaceGenerations.forEach((element) => {
        json.InterfaceGenerations.push(element.toJson());
      });
    }
    if (this.implements && this.implements.length > 0) {
      json.Implements = [];
      this.implements.forEach((element) => {
        json.Implements.push(element.toJson());
      });
    }
    if (this.associations && this.associations.length > 0) {
      json.Associations = [];
      this.associations.forEach((element) => {
        json.Associations.push(element.toJson());
      });
    }
    if (this.aggregations && this.aggregations.length > 0) {
      json.Aggregations = [];
      this.aggregations.forEach((element) => {
        json.Aggregations.push(element.toJson());
      });
    }
    if (this.compositions && this.compositions.length > 0) {
      json.Compositions = [];
      this.compositions.forEach((element) => {
        json.Compositions.push(element.toJson());
      });
    }
    if (this.crossAssociations && this.crossAssociations.length > 0) {
      json.CrossAssociations = [];
      this.crossAssociations.forEach((element) => {
        json.CrossAssociations.push(element.toJson());
      });
    }
    if (this.referCrossAssociations && this.referCrossAssociations.length > 0) {
      json.ReferCrossAssociations = [];
      this.referCrossAssociations.forEach((element) => {
        json.ReferCrossAssociations.push(element.toJson());
      });
    }
    if (this.exceptions && this.exceptions.length > 0) {
      json.Exceptions = [];
      this.exceptions.forEach((element) => {
        json.Exceptions.push(element.toJson());
      });
    }
    if (this.dependencyAssociations && this.dependencyAssociations.length > 0) {
      json.DependencyAssociations = [];
      this.dependencyAssociations.forEach((element) => {
        json.DependencyAssociations.push(element.toJson());
      });
    }
    if (this.distributedTransactions && this.distributedTransactions.length > 0) {
      json.DistributedTransactions = [];
      this.distributedTransactions.forEach((element) => {
        json.DistributedTransactions.push(element.toJson());
      });
    }
    if (this.externalServices && this.externalServices.length > 0) {
      json.ExternalServices = [];
      this.externalServices.forEach((element) => {
        json.ExternalServices.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): BEComponent {
    const bEComponent = new BEComponent();
    bEComponent.Deserialize(json);
    bEComponent.json = json;
    return bEComponent;
  }
}
